export const SHOP_THE_LOOK_FEATURE_KEY = 'shop-the-look';
export const OPENED_SHOP_THE_LOOK_FEATURE_KEY = 'opened';
export const SHOP_THE_LOOKS_FEATURE_KEY = 'look-books';
export const EDIT_SHOP_THE_LOOK_FEATURE_KEY = 'edit-look-book';
export const CORE_SHOP_THE_LOOK_FEATURE_KEY = 'core';
